import { useEffect } from 'react';
import { useForm, useFieldValue } from '@qover/hooks';
import { addDays, endOfDay, startOfDay } from '@qover/utils/src/date';

function SetStartDateNextDay() {
  const startDateField = useFieldValue<string>('startDate');
  const { change } = useForm();

  useEffect(() => {
    const startDate = new Date(startDateField);

    if (
      !startDateField ||
      (startDateField && startDate < endOfDay(new Date()))
    ) {
      change('startDate', startOfDay(addDays(new Date(), 1)).toISOString());
    }
  }, [startDateField]);

  return null;
}

export default SetStartDateNextDay;
